// extracted by mini-css-extract-plugin
export default {"layout":"style_layout__1EN8i","header":"style_header__0JEPP","main":"style_main__WzZdF"};